import { LOAN_REQUEST_USAGES } from 'cpool-constants';
import type { Resolver, Schema_OfferFilter } from 'cpool-schemas';
import { z } from 'zod';

import { AcceptedOffersTableDefinitionZod } from '../tables';

type Arguments = {
    filter?: Schema_OfferFilter;
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetAcceptedOffers = z.array(
    AcceptedOffersTableDefinitionZod.and(
        z.object({
            financingPurpose: z.nativeEnum(LOAN_REQUEST_USAGES).nullish(),
        }),
    ),
);

export type SchemaLoanRequestResolver_GetAcceptedOffers = z.infer<typeof schemaLoanRequestResolver_GetAcceptedOffers>;

export type LoanRequestResolver_GetAcceptedOffers = Resolver<Arguments, SchemaLoanRequestResolver_GetAcceptedOffers>;
